import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { LoaderPage } from "../../../component/Loader";

// id is the container of the current component which we want to render
export const SaveAsPdf = ({
  elementId = "",
  name = "Document.docx",
  quality = 1,
  disabled = false,
  isPdfReadyForDownload = false
}) => {
  const [isDownloading, setDownloding] = useState(false);

  // from html
  const onDownload = () => {
    if (elementId) {
      setDownloding(true); // start the loader
      window.scroll(0, 0);
      return new Promise(resolve => {
        const pdfSection = document
          .getElementById(elementId)
          .querySelectorAll(".pdf-section");
        const doc = new jsPDF("p", "px");

        // load all pages in promise
        const pagesPromise = [];
        for (let index = 0; index < pdfSection.length; index++) {
          const element = pdfSection[index];
          pagesPromise.push(html2canvas(element, { scale: quality }));
        }

        // load all pages
        Promise.all(pagesPromise)
          .then(data => {
            const imagesPromiseArr = []; // put images after resolved in promise
            data.forEach((canvas, index) => {
              const dataUrl = canvas.toDataURL();
              const resolveImagePromise = new Promise(resolve => {
                const imgElement = document.createElement("img");
                imgElement.onload = function() {
                  const margin = 5;
                  const imgProps = doc.getImageProperties(imgElement);
                  const pdfWidth = doc.internal.pageSize.getWidth() - margin;
                  const pdfHeight =
                    (imgProps.height * pdfWidth) / imgProps.width;
                  if (index > 0) {
                    doc.addPage();
                  }
                  doc.addImage(imgElement, "JPEG", 0, 0, pdfWidth, pdfHeight);
                  resolve(true);
                };
                imgElement.src = dataUrl;
              });

              imagesPromiseArr.push(resolveImagePromise);
            });

            // after load all images save the pdf
            Promise.all(imagesPromiseArr).then(() => {
              doc.save(name);
              resolve({ status: true, message: "Download Completed" });
              setDownloding(false); // start the loader
            });
          })
          .catch(console.error);
      });
    }
  };

  return elementId ? (
    <>
      <LoaderPage loading={isDownloading} />
      <Button disabled={disabled} size={"sm"} onClick={onDownload}>
        {isPdfReadyForDownload ? (
          <span>
            Loading <Spinner animation="grow" size="sm" />
          </span>
        ) : (
          "Download as Pdf"
        )}
      </Button>
    </>
  ) : null;
};
